import cn from "clsx";
import React, { useId } from "react";
import { Text } from "../text";
import styles from "./ProgressBar.module.scss";

export type ProgressBarProps = {
    /**
     * Progress in percent
     * @default 0
     */
    value?: number;
    /**
     * Text position above or below progress bar
     * @default top
     */
    positionText?: "top" | "bottom";
    /**
     * Horizontal alignment of the text
     * @default center
     */
    textHorizontalAlignment?: "left" | "center" | "right";
    /**
     * Classname applied to the detail text
     */
    detailClassName?: string;
    /**
     * Accessible title for the progress bar
     */
    accessibleTitle?: string;
};
export const ProgressBar: React.FC<ProgressBarProps> = ({
    value = 0,
    positionText = "top",
    textHorizontalAlignment = "center",
    detailClassName,
    accessibleTitle,
}) => {
    const textClass = cn(
        styles[`text-wrapper`],
        styles[`text-wrapper--${positionText}`],
        styles[`text-wrapper--${textHorizontalAlignment}`],
        detailClassName,
    );
    const labelId = useId();

    return (
        <div className={styles.container}>
            <Text.Detail
                className={textClass}
                id={labelId}
                aria-hidden={true}
                tag="span"
            >
                <span className="visually-hidden">{accessibleTitle}</span>{" "}
                {value}% complete
            </Text.Detail>
            <div
                role="progressbar"
                aria-labelledby={labelId}
                style={{ "--bar-width": `${value}%` } as React.CSSProperties}
                className={styles.bar}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={value}
            />
        </div>
    );
};
